import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

import Header from "../../../components/layout/Header/Header";
import Footer from "../../../components/layout/Footer/Footer";
import Container from "../../../components/layout/Container/Container";

import { getServices } from "../../../api/services";
import { useClinicInfo } from "../../../api/queries/useClinicInfo";
import { useGallery } from "../../../api/queries/useGallery";
import { toMap } from "../../../app/clinicInfoMap";

import s from "./ServicesPage.module.scss";

const DEFAULT_NOTE =
  'Список услуг подгружается автоматически. Скоро добавим разделы, цены "от",\nфото и фильтры — будет проще выбрать нужное.';

// Универсальная функция для корректного пути к картинке
function resolveImageUrl(path?: string) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith("/")) return path;
  return `/${path}`;
}

export default function ServicesPage() {
  const [data, setData] = useState<any>(null);

  // Загружаем услуги
  useEffect(() => {
    getServices().then(setData).catch(() => setData([]));
  }, []);

  // Загружаем gallery
  const { data: gallery } = useGallery();

  // Создаём карту id → image_path
  const galleryMap = useMemo(() => {
    const map = new Map<number, string>();
    (gallery ?? []).forEach((g) => {
      if (typeof g.id === "number") {
        map.set(g.id, g.image_path);
      }
    });
    return map;
  }, [gallery]);

  // Загружаем текст заметки
  const { data: info } = useClinicInfo();
  const cfg = useMemo(() => toMap(info ?? []), [info]);

  const noteText = (cfg["services.page.note"] || "").trim() || DEFAULT_NOTE;

  return (
    <div className={s.pageWrap}>
      <Header />

      <main className={s.main}>
        <section className="section section--tight">
          <Container>
            <div className={s.panel}>
              <h1 className={s.h1}>Услуги</h1>

              <p className={s.p} style={{ whiteSpace: "pre-line" }}>
                {noteText}
              </p>

              <div className={s.grid}>
                {Array.isArray(data)
                  ? data.map((item: any) => {
                      // Получаем путь к картинке услуги
                      const rawPath = item.image_path_id
                        ? galleryMap.get(item.image_path_id)
                        : "";
                      const imgSrc = resolveImageUrl(rawPath);

                      return (
                        <Link
                          key={item.id}
                          to={`/services/${item.id}`}
                          className={s.card}
                        >
                          <div className={s.contentText}>
                            <div className={s.title}>{item.title}</div>

                          {item.description ? (
                            <div className={s.desc}>{item.description}</div>
                          ) : null}

                          {item.price != null ? (
                            <div className={s.price}>{item.price} ₽</div>
                          ) : null}
                          </div>
                          <div className={s.contentImage}>
                            <div className={s.thumb}>
                            {imgSrc ? (
                              <img
                                src={imgSrc}
                                alt={item.title}
                                className={s.img}
                                loading="lazy"
                                onError={(e) => {
                                  // Если сервер не отдаёт статику — скрываем картинку
                                  (e.currentTarget as HTMLImageElement).style.display =
                                    "none";
                                }}
                              />
                            ) : (
                              <div className={s.thumbPlaceholder} />
                            )}
                          </div>
                          </div>

                          

                          
                        </Link>
                      );
                    })
                  : null}
              </div>
            </div>
          </Container>
        </section>
      </main>

      <Footer />
    </div>
  );
}

